/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `horizontal` - horizontal
 * `vertical` - vertical
 */
export type OrientationEnum =
  (typeof OrientationEnum)[keyof typeof OrientationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrientationEnum = {
  horizontal: "horizontal",
  vertical: "vertical",
} as const;
